/*jshint esversion: 6 */
/* global interact */
import { Controller } from "stimulus";
import Sortable from 'sortablejs';
import { htmlToElement } from '.././helpers/dom';

export default class extends Controller {
  static targets = [ "transcriptInstitutionTemplate", "transcriptInstitutionsFormContainer", "transcriptInstitutionName", "transcriptInstitutionForm" ]

  connect() {
    // if (this.hasSchoolSubjectAreaFormTarget) {
    //   // Show the first skill category while all others are hiding
    //   this.transcriptInstitutionFormTargets[0].classList.toggle('hidden');
    // }

    // Make the skill category selectors sortable
    const sortable = document.querySelector('#transcript-institutions-sortable.sortable');
    var el = Sortable.create(sortable, {
      animation: 150,
      draggable: "li.btn",
      filter: ".ignore-sort",
      forceFallback: true,
      onEnd: function(event) {
        let transcriptInstitutionId = event.item.getAttribute('data-transcript-institution-id');
        document.querySelector(`[data-transcript-institution-id="${transcriptInstitutionId}"] input.position`).value = event.newIndex + 1;
      }
    });

    // Highlight initial skill category
    // document.querySelector('#transcript-institutions-sortable.sortable li').classList.add('btn-pink');
  }

  switchTo(event) {
    this.transcriptInstitutionFormTargets.forEach((el, i) => {
      el.classList.toggle("hidden", el.dataset.transcriptInstitutionId != event.target.dataset.transcriptInstitutionId)
    });

    // Highlight selected tab
    let sortableSelector = '#transcript-institutions-sortable.sortable li.btn-pink'
    if (document.querySelector(sortableSelector) != null) {
      document.querySelector(sortableSelector).classList.remove('btn-pink');
    }
    event.target.classList.add('btn-pink');
  }

  addNewItem(event) {
    const id = new Date().getTime();
    const template = `<li class='inline-block mr-10 mb-14 btn' data-target='schools--transcript-institutions.transcriptInstitutionName' data-action='click->schools--transcript-institutions#switchTo' data-transcript-institution-id='${id}'>New Instutition</li>`
    const newElementLink = htmlToElement(template);
    const parentElement = document.getElementById("transcript-institutions-sortable");
    parentElement.insertAdjacentElement("beforeend", newElementLink);
    newElementLink.addEventListener("click", (ev) => {
      this.switchTo(ev);
    });
    const newElementForm = htmlToElement(this.transcriptInstitutionTemplateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, id));
    newElementForm.dataset.transcriptInstitutionId = id;
    this.transcriptInstitutionsFormContainerTarget.insertAdjacentElement('beforeend', newElementForm);

    window.expandableTextArea();
    newElementLink.click();
  }

  updateTitle(event) {
    const transcriptInstitutionId = event.target.parentElement.parentElement.parentElement.dataset.transcriptInstitutionId;
    this.transcriptInstitutionNameTargets.find(el => el.dataset.transcriptInstitutionId  == transcriptInstitutionId).innerText = event.target.value;
  }

  removeItem(event) {
    if (confirm('Are you sure?') == true) {
      const itemForm = event.target.parentElement;
      const transcriptInstitutionId = itemForm.dataset.transcriptInstitutionId;
      this.transcriptInstitutionNameTargets.find(el => el.dataset.transcriptInstitutionId  == transcriptInstitutionId).style.display = 'none';
      itemForm.querySelector("input[name*='_destroy']").value = 1;
      itemForm.style.display = 'none';
    }
  }

  _insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  _insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }
}
